import React from "react";
import DynamixTrousers from "../Garments/Dynamix";

export default function DynamixPage() {
  return <DynamixTrousers />;
}
